import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/rubInCircle.svg';

export const IconRubInCircle = createIconComponent(Icon);
